export default __webpack_public_path__ + "close_x.3869b70d32167baa33ec21363d12c3f2.svg";